/*
 * @Author: Betway huangbo@mrcdevlab.com
 * @Date: 2024-04-16 16:57:56
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2025-07-30 17:52:01
 * @FilePath: \mrc-ess-base-frontend\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-06-12 18:37:02
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-02 09:34:44
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Cookie from "js-cookie";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "../store/index";
import { btnPermissionList } from "@/service/api/btnPermission";
// import asyncRouter from './asyncRouter'
import allRouters from "./allRouters";
import ls from '@/utils/Ls'

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 路由有name 在面包屑才有层级

// 菜单
// 显示layout的菜单栏就写name 和 alwaysShow
// 不显示就不写name 和 alwaysShow

const baseRouter = [
  {
    path: "/login",
    name: "login",
    alias: "/",
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/forget-password",
    name: "forget-password",
    component: () => import("@/views/forget-password/index.vue"),
  },
  {
    // path: '/reset-password/:token?',/reset-account-credential
    path: "/reset-account-credential/:token?", //2021.7.29 18.42 yd改
    name: "reset-password",
    component: () => import("@/views/reset-password/index.vue"),
  },
  {
    path: "/secondary_confirmation/:token?",
    name: "secondary_confirmation",
    component: () => import("@/views/login/login_secondary_confirmation.vue"),
  },
  {
    path: "/404",
    name: "notFound",
    component: () => import("@/views/errorPage/404.vue"),
  },
  ...allRouters,
];

// const routes = baseRouter.concat(asyncRouter)
const router = new VueRouter({
  // mode: 'hash',//2021-04-02 brain
  mode: "history",
  base: process.env.BASE_URL,
  // base: "mrc-base-server",
  routes: baseRouter,
  scrollBehavior: () => ({
    y: 0,
  }),
});

let flag;
NProgress.configure({ showSpinner: false });

const whiteList = ["/", "login", "forget-password", "reset-password", "404"];
router.beforeEach(async (to, from, next) => {
  store.commit("set_page_title", to.meta.title);
  // to.meta.title = 'label_New_department'
  if (store.state.allMenuUrlList.length > 0) {
    if (store.state.allMenuUrlList.some((item) => item.url == to.fullPath)) {
      to.meta.title = store.state.allMenuUrlList.filter(
        (item) => item.url == to.fullPath
      )[0].title;
    } else {
      // console.log(to.meta.title, 'to.meta.title');
    }
  }
  try {
    // const res = await btnPermissionList({
    //     function_uuid: store.getters.menuFunctionUuid
    // })
    // store.commit('setBtnPermission', res.data ? res.data : [])
    NProgress.start();
    const r = JSON.parse(sessionStorage.getItem("sideMenu"));
    const token = ls.get("token");
    if (whiteList.every((item) => to.fullPath.indexOf(item) <= -1)) {
      // 没有菜单列表就去登录界面
      if (!r || r.length <= 0) {
        // store.commit('set_sideMenu', asyncRouter)
        // next({ name: 'login', replace: true })
      }
      // 记得复原
      if (!token) {
        // '没有token'
        next({
          path: `/login`,
          query: { redirect: `${to.name}` },
          replace: true,
        });
      }
      next();
    } else {
      if (to.matched.length === 0) {
        next("/404"); // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
      }
      next();
    }
  } catch (err) {
    next();
  }

  // if (to.path == '/game/aaaa' || to.path == '/game/bbbb') { // 当进入这个页面进行记录
  //   flag = true; // 改变信号
  //   next();
  // } else {
  //   if (flag) { // 如果路由发生变化判断信号
  //     Vue.prototype.$myConfirm({
  //       content: this.$t('message_Confirm_the_deletion')
  //     }).then(() => {
  //       next()
  //       flag = false;
  //     })
  //   } else {
  //     next()
  //   }
  // }
});

router.afterEach((to, from) => {
  NProgress.done();
});
export default router;
